<template>
    <div class="Section FAQ" id="faq">
        <SiteFAQ
            :faqs="faqs"
            title="Alles was Sie wissen müssen"
            subtitle="Beantwortet in unseren FAQs"
            theme="light"
        />
    </div>
</template>

<script>
import SiteFAQ from '@/components/SiteFAQ.vue';
import { trackContent } from '@/services/analytics';

export default {
    name: 'FAQ',
    components: {
        SiteFAQ,
    },
    data() {
        return {
            faqs: [
                {
                    question: 'Was ist TaxiFusion?',
                    answer: `
                        <p>TaxiFusion ist eine moderne Softwarelösung speziell für Taxi- und Mietwagenunternehmen.
                        Die Plattform bietet alles was Sie für den täglichen Betrieb brauchen: Von der Fahrer- und
                        Fahrzeugverwaltung über Umsatzanalysen bis hin zur TSE-konformen Datenspeicherung.</p>
                    `,
                },
                {
                    question: 'Ist die Registrierung kostenlos?',
                    answer: `
                     <p>Die Anmeldung bei TaxiFusion ist vollständig kostenlos und unverbindlich.  
Sie können sich jederzeit registrieren und die Plattform nutzen, solange noch kein Fahrzeug gekoppelt ist.  
Erst mit der Kopplung Ihres ersten Fahrzeugs über eine Werkstatt beginnt die kostenpflichtige Nutzung gemäß dem von Ihnen gewählten Tarif.</p>  
<p>Während der kostenlosen Phase entstehen keinerlei Gebühren oder automatische Abbuchungen.  
Jedes Fahrzeug ist monatlich kündbar, und die Abrechnung erfolgt stets erst nach dem abgeschlossenen Nutzungsmonat.</p>
                    `,
                },
                {
                    question: 'Wie viel kostet TaxiFusion?',
                    answer: `
                        <p>TaxiFusion bietet flexible Tarife für jeden Bedarf:</p>
                        <ul>
                            <li><strong>Lite (10€/Monat):</strong> Grundfunktionen für kleine Betriebe</li>
                            <li><strong>Basic (16€/Monat):</strong> Vollständige Lösung inkl. TSE-Kompatibilität</li>
                        </ul>
                        <p>Alle Preise verstehen sich pro Fahrzeug und Monat zzgl. MwSt.</p>
                    `,
                },
                {
                    question: 'Ist TaxiFusion TSE-konform?',
                    answer: `
                        <p>Ja, TaxiFusion ist vollständig TSE-konform und unterstützt alle gängigen TSE-Systeme:</p>
                        <ul>
                            <li>Hale Taxameter und TSE-Module</li>
                            <li>Semitron TSE-Lösungen</li>
                            <li>Digitax TSE-Systeme</li>
                        </ul>
                        <p>Die Software übernimmt die rechtssichere Datenspeicherung und erfüllt alle
                        Anforderungen der Kassensicherungsverordnung.</p>
                    `,
                },
                {
                    question: 'Wie funktioniert die mobile Fahrer-App?',
                    answer: `
                        <p>Die TaxiFusion Fahrer-App ist Ihr mobiles Büro für unterwegs:</p>
                        <ul>
                            <li><strong>Echtzeit-Updates:</strong> Alle Fahrten und Änderungen werden sofort synchronisiert</li>
                            <li><strong>Intuitive Bedienung:</strong> Einfache Eingabe von Fahrtdaten und Pausen</li>
                            <li><strong>TSE-konform:</strong> Automatische Erfassung aller relevanten Daten</li>
                        </ul>
                        <p>Die App ist kostenlos im App Store und bei Google Play verfügbar.</p>
                    `,
                },
                {
                    question: 'Wie lange dauert die Einrichtung?',
                    answer: `
                        <p>Die Einrichtung von TaxiFusion ist schnell und unkompliziert:</p>
                        <ul>
                            <li><strong>Online-Anmeldung:</strong> In wenigen Minuten erledigt</li>
                            <li><strong>Technische Einrichtung:</strong> 1-2 Tage (abhängig von der Flottengröße)</li>
                            <li><strong>Live gehen:</strong> Meist innerhalb einer Woche</li>
                        </ul>
                        <p>Unser Support-Team begleitet Sie durch den gesamten Prozess.</p>
                    `,
                },
                {
                    question: 'Welche Unterstützung bieten Sie?',
                    answer: `
                        <p>Wir unterstützen Sie persönlich und direkt bei allen Fragen zu TaxiFusion:</p>
                        <ul>
                            <li><strong>E-Mail-Support:</strong> support@taxifusion.de</li>
                            <li><strong>Telefon-Support:</strong> 030 959982020</li>
                            <li><strong>Erreichbarkeit:</strong> Montag - Freitag, 10:00 - 15:00 Uhr</li>
                            <li><strong>Dokumentation:</strong> Umfangreiche Anleitungen und Tutorials</li>
                            <li><strong>Updates:</strong> Automatische Software-Updates</li>
                        </ul>
                        <p>Unser Support-Team steht Ihnen gerne zur Verfügung und hilft Ihnen schnell und kompetent weiter.</p>
                    `,
                },
                {
                    question: 'Kann ich TaxiFusion auch mit meinem bestehenden Taxameter nutzen?',
                    answer: `
                        <p>Ja, TaxiFusion ist kompatibel mit allen gängigen Taxametern:</p>
                        <ul>
                            <li><strong>Hale:</strong> Alle Modelle mit digitaler Schnittstelle</li>
                            <li><strong>Semitron:</strong> Kompatibel mit aktuellen Modellen</li>
                            <li><strong>Digitax:</strong> Vollständige Integration möglich</li>
                            <li><strong>Andere Hersteller:</strong> Auf Anfrage geprüft</li>
                        </ul>
                        <p>Bei älteren Modellen kann ein Upgrade oder TSE-Nachrüstung erforderlich sein.
                        Wir beraten Sie gerne zu den besten Optionen für Ihre Flotte.</p>
                    `,
                },
                {
                    question: 'Wie sicher sind meine Daten?',
                    answer: `
                        <p>Datenschutz und Sicherheit haben bei uns höchste Priorität:</p>
                        <ul>
                            <li><strong>DSGVO-konform:</strong> Alle Daten werden EU-DSGVO-konform verarbeitet</li>
                            <li><strong>SSL-Verschlüsselung:</strong> Alle Datenübertragungen sind verschlüsselt</li>
                            <li><strong>Deutsche Server:</strong> Daten werden in Deutschland gehostet</li>
                            <li><strong>Regelmäßige Backups:</strong> Automatische Datensicherung</li>
                            <li><strong>Zugriffskontrollen:</strong> Rollenbasierte Berechtigungen</li>
                        </ul>
                        <p>Ihre sensiblen Geschäftsdaten sind bei uns sicher aufgehoben.</p>
                    `,
                },
                {
                    question: 'Gibt es eine Mindestvertragslaufzeit?',
                    answer: `
                        <p>Nein, es gibt keine Mindestvertragslaufzeit bei TaxiFusion.</p>
                        <p>Sie zahlen ganz einfach monatlich und können jederzeit kündigen. Ihre Daten bleiben dabei vollständig exportierbar.</p>
                    `,
                },
            ],
        };
    },
    mounted() {
        // Track FAQ section view
        trackContent.blogPostView('faq_section', {
            context: 'landing_page',
        });
    },
};
</script>

<style lang="scss">
.FAQ {
}
</style>
